export default "__VITE_ASSET__D0B58Ia1__"